export const setMe = ({ peerId, loginEnabled }) =>
({
	type: 'SET_ME',
	payload: { peerId, loginEnabled }
});

export const setMyPeerId = (peerId) =>
({
	type: 'SET_MY_PEER_ID',
	payload: { peerId }
});

export const setBrowser = (browser) =>
({
	type    : 'SET_BROWSER',
	payload : { browser }
});

export const setLoggedIn = (flag) =>
({
	type    : 'SET_LOGGED_IN',
	payload : { flag }
});

export const setLoggedExpired = (flag) =>
({
	type    : 'SET_LOGGED_EXPIRED',
	payload : { flag }
});

export const addRole = (role) =>
({
	type    : 'ADD_ROLE',
	payload : { role }
});

export const removeRole = (role) =>
({
	type    : 'REMOVE_ROLE',
	payload : { role }
});

export const setPicture = (picture) =>
({
	type    : 'SET_PICTURE',
	payload : { picture }
});

export const setMediaCapabilities = ({
	canSendMic,
	canSendWebcam,
	canShareScreen,
	canShareFiles
}) =>
({
	type    : 'SET_MEDIA_CAPABILITIES',
	payload : { canSendMic, canSendWebcam, canShareScreen, canShareFiles }
});

export const setAudioDevices = (devices) =>
({
	type    : 'SET_AUDIO_DEVICES',
	payload : { devices }
});

export const setAudioOutputDevices = (devices) =>
({
	type    : 'SET_AUDIO_OUTPUT_DEVICES',
	payload : { devices }
});

export const setWebcamDevices = (devices) =>
({
	type    : 'SET_WEBCAM_DEVICES',
	payload : { devices }
});

export const setRaisedHand = (flag) =>
({
	type    : 'SET_RAISED_HAND',
	payload : { flag }
});

export const setAudioInProgress = (flag) =>
({
	type    : 'SET_AUDIO_IN_PROGRESS',
	payload : { flag }
});

export const setAudioOutputInProgress = (flag) =>
({
	type    : 'SET_AUDIO_OUTPUT_IN_PROGRESS',
	payload : { flag }
});

export const setWebcamInProgress = (flag) =>
({
	type    : 'SET_WEBCAM_IN_PROGRESS',
	payload : { flag }
});

export const setPreloadWebcam = (flag) =>
({
	type    : 'SET_PRELOAD_WEBCAM',
	payload : { flag }
});


export const setScreenShareInProgress = (flag) =>
({
	type    : 'SET_SCREEN_SHARE_IN_PROGRESS',
	payload : { flag }
});

export const setRaisedHandInProgress = (flag) =>
({
	type    : 'SET_RAISED_HAND_IN_PROGRESS',
	payload : { flag }
});

export const setDisplayNameInProgress = (flag) =>
({
	type    : 'SET_DISPLAY_NAME_IN_PROGRESS',
	payload : { flag }
});

export const setIsSpeaking = (flag) =>
({
	type    : 'SET_IS_SPEAKING',
	payload : { flag }
});

export const setAutoMuted = (flag) =>
({
	type    : 'SET_AUTO_MUTED',
	payload : { flag }
});

// 设置被强制静音状态
export const setForceMuted = (flag) =>
({
	type: 'SET_FORCE_MUTED',
	payload: { flag }
});

// 被强制静音了，申请请求
export const setApplyUnMuted = (flag) =>
({
	type: 'SET_APPLY_UNMUTED',
	payload: { flag }
});

// 被强制静音了，申请结果
export const setAllowUnMuted = (flag) =>
({
	type: 'SET_ALLOW_UNMUTED',
	payload: { flag }
});

// 申请处理中
export const setApplyUnMutedInProgress = (flag) =>
({
	type: 'SET_APPLY_UNMUTED_IN_PROGRESS',
	payload: { flag }
});

export const setChairAudioMuteInProgress = (flag) =>
({
	type: 'SET_CHAIR_AUDIO_MUTE_IN_PROGRESS',
	payload: { flag }
});

export const setChairVideoMuteInProgress = (flag) =>
({
	type: 'SET_CHAIR_VIDEO_MUTE_IN_PROGRESS',
	payload: { flag }
});

// 保存用户登录成功后的信息
export const setUserInfo = (userInfo) =>
({
	type: 'SET_USER_INFO',
	payload: { userInfo }
});
// 开启虚拟背景
export const setVirtualRealityEnabled = (flag) =>
({
	type: 'SET_VIRTUAL_REALITY_ENABLED',
	payload: { flag }
});
// 虚拟背景图
export const setVirtualBgUrl = (imgUrl) =>
({
	type: 'SET_VIRTUAL_BG_URL',
	payload: { imgUrl }
});
// 登录类型
export const setLoginType = (loginType) =>
({
	type: 'SET_LOGIN_TYPE',
	payload: { loginType }
});
